export default __webpack_public_path__ + "static/media/Mockup1.6336a73e.png";